import banner2 from "../../img/autoagendamientov2/banner2.jpg"
import logo1 from '../../img/autoagendamientov2/logo_ike_home.png'

export default function Banner2(){

    return (
        <div className="d-banner-1">
            <div className="d-1 column--50-first ft-monserratbold">
                <h1 className="mb-0 label">Toda nuestra </h1>
                <h1 className="colorTitle">experiencia para</h1>
                <h1 className="label">el cuidado de tu salud</h1>                
            </div>
            <div className="d-logo-center">
                <img 
                    src={logo1}
                    alt="Ike"
                    width={150}
                />
            </div>
            <div className="d-2 d-none d-md-block">
                <img 
                    src={banner2}
                    alt="Ike"
                    width={800}
                />
            </div>
        </div>
    )
}